var map = {
	"./01.png": 5873,
	"./02.png": 8619,
	"./03.png": 3170,
	"./04.png": 2202,
	"./1.jpg": 8475,
	"./2.jpg": 5720,
	"./3.jpg": 6093,
	"./404.png": 2272,
	"./BagMagic_Logo-01.png": 9384,
	"./CostWorld_Logo01.png": 2336,
	"./Loader/Untitled.jpg": 7504,
	"./Loader/loader.gif": 9164,
	"./Mehr_Logo-01.png": 9827,
	"./OTGroup_Logo.png": 7496,
	"./TheOnlineMirrorShop_Logo-01.png": 5739,
	"./Tomo_Logo.png": 2950,
	"./Untitled-3.jpg": 2200,
	"./about-1.jpg": 8344,
	"./about-9.jpg": 9429,
	"./about/about-10.jpg": 4906,
	"./about/about-11.jpg": 2668,
	"./about/about_top.jpg": 6863,
	"./about/block-bg-2.png": 8472,
	"./about/cyber_security_icon.png": 621,
	"./about/faq-2.jpg": 1322,
	"./about/fully_commited.png": 2142,
	"./about/history-img-1.jpg": 3386,
	"./about/img_10.jpg": 1751,
	"./about/img_11.jpg": 2762,
	"./about/img_12.jpg": 3092,
	"./about/img_13.jpg": 5689,
	"./about/img_14.jpg": 1581,
	"./about/img_7.jpg": 1856,
	"./about/img_8.jpg": 1300,
	"./about/img_9.jpg": 2919,
	"./about/mission.png": 7744,
	"./about/mob_app_icon.png": 9434,
	"./about/mutual_nature.png": 4246,
	"./about/our delivery process/agiles-project-management.jpg": 7861,
	"./about/our delivery process/blog-5.jpg": 7287,
	"./about/our delivery process/jira-pmt.jpg": 9180,
	"./about/our delivery process/management-and-optimize.jpg": 8685,
	"./about/our delivery process/our_work_process_banner.jpg": 2424,
	"./about/product_stategy_icon.png": 4227,
	"./about/technical_ex.png": 7511,
	"./about/testing_icon.png": 9872,
	"./about/text-bg.jpg": 9599,
	"./about/vastly_experienced.png": 8045,
	"./about/web_design_icon.png": 1642,
	"./about/why_choose_us.jpg": 7600,
	"./arrow-1.png": 4649,
	"./arrow-2.png": 7876,
	"./artificial-intelligence.png": 9752,
	"./augmented_reality.png": 8314,
	"./banner1.jpg": 1807,
	"./banner1.webp": 4401,
	"./blog/banner-1.jpg": 394,
	"./blog/blog-standard-1.jpg": 2842,
	"./blog/blog-standard-2.jpg": 1124,
	"./blog/blog-standard-3.jpg": 1592,
	"./blog/blog-standard-4.jpg": 1309,
	"./blog/post-thumb-1.jpg": 3914,
	"./blog/post-thumb-2.jpg": 2367,
	"./blog/post-thumb-3.jpg": 3697,
	"./blog/post-thumb-4.jpg": 3455,
	"./blog/user-1.jpg": 3656,
	"./blog/user-2.jpg": 5112,
	"./brand_representation.png": 2069,
	"./breadcrumbs-bg-1.jpg": 4501,
	"./career/img-10.jpg": 315,
	"./career/img-7.jpg": 4839,
	"./career/img-8.jpg": 8352,
	"./career/img-9.jpg": 565,
	"./career/increment.png": 6266,
	"./career/no_vacancy.jpg": 5822,
	"./career/no_vacancy.png": 4852,
	"./career/secure-shield.png": 457,
	"./career/support.png": 6079,
	"./career/work-flexible.png": 7452,
	"./case-study/1-520x640.jpg": 8938,
	"./case-study/2-520x640.jpg": 6437,
	"./case-study/3-520x640.jpg": 1349,
	"./case-study/4-1-520x640.png": 1944,
	"./case-study/5-1-520x640.png": 4923,
	"./case-study/6-2-520x640.png": 1531,
	"./case-study/uk_pallet.jpg": 3160,
	"./case-study/uk_pallet_details.jpg": 6711,
	"./case_study_bg.jpg": 8789,
	"./case_study_item1.jpg": 998,
	"./case_study_item2.jpg": 8997,
	"./case_study_item3.jpg": 5912,
	"./chart_icon.png": 7262,
	"./consultancy_banner.jpg": 8129,
	"./contact/location.png": 3901,
	"./contact/mail.png": 7349,
	"./contact/phone-call.png": 585,
	"./content_creation.png": 3602,
	"./cta-bg-2.jpg": 2249,
	"./customer1.png": 5377,
	"./customer2.png": 1404,
	"./darvish_tech_br7.png": 8506,
	"./deploy.png": 928,
	"./desenfunda_br3.png": 4459,
	"./design.png": 7613,
	"./development.png": 9272,
	"./dot.png": 8442,
	"./dream-furnishings_br9.png": 4128,
	"./epolis_br5.png": 3658,
	"./error.png": 889,
	"./expertise.png": 904,
	"./extend.png": 3198,
	"./firstcome.jpg": 2465,
	"./firstcome_bg.jpg": 7882,
	"./flaticon-help.png": 2723,
	"./footer_bg.jpg": 4609,
	"./gallery-10.jpg": 632,
	"./gallery-11.jpg": 5752,
	"./gallery-9.jpg": 6319,
	"./gather_br4.png": 3866,
	"./gor_br8.png": 8909,
	"./hero-5_img-1.png": 8663,
	"./icon-1.png": 5681,
	"./icon-2.png": 8140,
	"./icon-3.png": 3937,
	"./icon-4.png": 378,
	"./img_1.jpg": 9296,
	"./img_2.jpg": 6830,
	"./img_3.jpg": 653,
	"./img_4.jpg": 5426,
	"./img_5.jpg": 8814,
	"./img_6.jpg": 4450,
	"./inside_hotel_br9.png": 484,
	"./knoll_br8.png": 6592,
	"./landport.png": 6311,
	"./latest_news1.jpg": 93,
	"./latest_news2.jpg": 7489,
	"./latest_news3.jpg": 64,
	"./logo-1.png": 3077,
	"./logo-2.png": 7429,
	"./logo-contact.png": 857,
	"./machine-learning.png": 4672,
	"./menu_icons/Car-renta.png": 1608,
	"./menu_icons/Case-Study.png": 8466,
	"./menu_icons/College-management.png": 423,
	"./menu_icons/Restaurant-Management.png": 5380,
	"./menu_icons/School-Management.png": 7003,
	"./menu_icons/about.png": 3681,
	"./menu_icons/career.png": 3021,
	"./menu_icons/choose-us.png": 8097,
	"./menu_icons/guest-house-management-system.png": 7075,
	"./menu_icons/menu.png": 1333,
	"./menu_icons/our-team.png": 2155,
	"./mercato_br1.png": 4972,
	"./news_letter_bg.png": 3074,
	"./notification.png": 5982,
	"./optimise.png": 5631,
	"./otgroup.png": 126,
	"./plan.png": 5952,
	"./platform/booking_icon.png": 1597,
	"./platform/dine_in.png": 1268,
	"./platform/dine_in_banner.png": 6059,
	"./platform/email.png": 7407,
	"./platform/gallery-1.jpg": 8150,
	"./platform/gallery-2.jpg": 6918,
	"./platform/hotel_icon.png": 2854,
	"./platform/kitchen.png": 6730,
	"./platform/menu_management.png": 175,
	"./platform/reciepe_management_module.png": 716,
	"./platform/revenue_management_icon.png": 9814,
	"./platform/testimonial-bg-2.jpg": 2656,
	"./portfolio.zip": 5161,
	"./portfolio/aqualogis.jpg": 9825,
	"./portfolio/bookodisha.jpg": 5598,
	"./portfolio/mercato.jpg": 9287,
	"./portfolio/project-26.jpg": 569,
	"./portfolio/project-27.jpg": 5661,
	"./portfolio/project-28.jpg": 2182,
	"./portfolio/project-29.jpg": 3022,
	"./portfolio/project-30.jpg": 3131,
	"./portfolio/project-31.jpg": 9207,
	"./portfolio/project-32.jpg": 1229,
	"./portfolio_bg.png": 1634,
	"./powerful_database.png": 6448,
	"./product_engineering.png": 2544,
	"./project-1.jpg": 42,
	"./project-2.jpg": 7314,
	"./project-3.jpg": 9214,
	"./project_planning.png": 2583,
	"./quote_portfolio.png": 2546,
	"./request_meeting.png": 2731,
	"./service/cta-bg-2.jpg": 4770,
	"./service/icon-10.png": 8982,
	"./service/icon-5.png": 5422,
	"./service/icon-6.png": 3641,
	"./service/icon-7.png": 7960,
	"./service/icon-8.png": 2899,
	"./service/icon-9.png": 535,
	"./service/thumb-3.jpg": 4342,
	"./service/thumb-4.jpg": 9432,
	"./service/thumb-5.jpg": 342,
	"./service_bg.png": 3411,
	"./service_details/01.jpg": 3178,
	"./service_details/01.png": 1079,
	"./service_details/02.jpg": 8197,
	"./service_details/02.png": 7173,
	"./service_details/03.jpg": 4691,
	"./service_details/03.png": 8558,
	"./service_details/04.png": 9029,
	"./service_details/05.png": 1369,
	"./service_details/about-9.jpg": 6654,
	"./service_details/amazon_service/img-01 2.jpg": 833,
	"./service_details/amazon_service/img-02.jpg": 2501,
	"./service_details/amazon_service/img-03.jpg": 5018,
	"./service_details/amazon_service/img-04.jpg": 303,
	"./service_details/amazon_service/img-6.png": 4383,
	"./service_details/amazon_why_choose_us1.jpg": 9643,
	"./service_details/amazon_why_choose_us11.jpg": 8496,
	"./service_details/amazon_why_choose_us2.jpg": 9793,
	"./service_details/amazone.webp": 688,
	"./service_details/artificial-intelligence.png": 3468,
	"./service_details/augmented_reality.png": 3104,
	"./service_details/bookodisha_home.png": 1030,
	"./service_details/bookodisha_home_full.png": 5219,
	"./service_details/complete.png": 2421,
	"./service_details/customer-feedback.png": 7235,
	"./service_details/dream_furnishing.jpg": 2339,
	"./service_details/evaluation.png": 4038,
	"./service_details/holidays.jpg": 4790,
	"./service_details/img1.png": 8612,
	"./service_details/inventory_optimisation.png": 67,
	"./service_details/machine-learning.png": 2438,
	"./service_details/mercato_place_home.png": 5076,
	"./service_details/mercato_place_home_full.png": 275,
	"./service_details/product-return.png": 1593,
	"./service_details/uk-pallet.jpg": 5155,
	"./service_details/warehouse_management.png": 606,
	"./service_icon1.png": 8970,
	"./service_icon2.png": 7791,
	"./service_icon3.png": 4755,
	"./service_icon4.png": 7979,
	"./sisti_br6.png": 4409,
	"./site_launch.png": 9145,
	"./sitemap_servicedetails.png": 7948,
	"./social_icon/twitter.png": 5782,
	"./social_icon/twitter1.png": 2008,
	"./start_planning.png": 9468,
	"./sub_menu_service_img.png": 1573,
	"./system_active_br2.png": 5738,
	"./sytner.png": 4046,
	"./sytner1.png": 4738,
	"./technical-support.png": 3162,
	"./testimonial-bg-1.jpg": 9518,
	"./testimonial/1click4all-logo.jpg": 1485,
	"./testimonial/clint-gagan.jpg": 3410,
	"./testimonial/dribbble_4x.webp": 5299,
	"./testimonial/drondaron.jpg": 1301,
	"./testimonial/m4karting.jpg": 8514,
	"./testing_service_details.png": 3958,
	"./user-1.jpg": 1502,
	"./user-2.jpg": 6723,
	"./user-3.jpg": 8589,
	"./what_we_do.png": 7502
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4339;